module.exports = __webpack_public_path__ + "static/image/promotion-p2.svg?5bcaec5aa875d61ba1f88bbf67e8e4a1";